
import PageHero from '../../../components/base/PageHero';

const FAQHeroSection: React.FC = () => {
  return (
    <PageHero
      breadcrumb="FAQ"
      label="Help Centre"
      title="Frequently Asked Questions"
      description="Answers to the most common questions about our training programmes, SETA compliance, learnerships, and how to get started with Sylman Academy."
    />
  );
};

export default FAQHeroSection;
